export default "__VITE_PUBLIC_ASSET__1f1629fc__"